import { makeStyles } from 'tss-react/mui';
import { link } from '../../styles/jss/utils';
import { colors, spacing } from '../../styles/jss/variables';
const useStyles = makeStyles()((theme) => ({
    availabilityChecker: {
        display: 'flex',
        flexDirection: 'column',
        padding: spacing.small,
        gap: '12px',
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row',
            flexWrap: 'wrap',
            justifyContent: 'center',
        },
        backgroundColor: '#e8e8e8',
    },
    availabilitySelectors: {
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        alignContent: 'center',
        borderRadius: '4px',
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row',
            flexWrap: 'wrap',
            justifyContent: 'center',
        },
        [theme.breakpoints.down('md')]: {
            '& :nth-of-type(n+3)': {
                display: 'none',
            },
        },
    },
    actionButton: {
        '&.MuiButtonBase-root.MuiButton-root': { padding: `15px ${spacing.large} 13px ${spacing.large}` },
        alignSelf: 'center',
    },
    basicButton: Object.assign(Object.assign({}, (theme.isFlyingFlowers ? link() : link(colors.primary.gold4))), { color: theme.isFlyingFlowers ? colors.black[700] : colors.primary.gold5 }),
    // ── Category PCC (hideOccasion variant) ──────────────────────────────────
    categoryAvailabilityChecker: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: `12px ${spacing.xs}`,
        backgroundColor: colors.grey.grey1,
        '& > *:not(:last-child)': {
            marginBottom: '12px',
            [theme.breakpoints.up('md')]: {
                marginBottom: 0,
                marginRight: '12px',
            },
        },
        [theme.breakpoints.up('md')]: {
            flexDirection: 'row',
            flexWrap: 'nowrap',
            justifyContent: 'center',
        },
    },
    categoryPccTitle: Object.assign(Object.assign(Object.assign({}, theme.typography.small_bold), theme.typographySpacing.none), { color: colors.grey.grey7, textAlign: 'center', flexShrink: 0, margin: 0, [theme.breakpoints.up('sm')]: {
            textAlign: 'left',
        } }),
    categoryPccSelectors: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        alignItems: 'center',
        justifyContent: 'center',
        '& > *:not(:last-child)': {
            marginRight: spacing.xs,
            [theme.breakpoints.up('md')]: {
                marginRight: '12px',
            },
        },
        // Override AvailabilitySelect pill padding for compact Figma appearance
        '& button:not(.MuiButton-root)': {
            padding: spacing.xs,
            width: 'auto',
        },
        // Override helper icon colour in category PCC context
        '& [class*="helperIconColor"]': {
            color: colors.supplementary.black,
        },
    },
    categoryPccAddressSelector: {
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
    categoryPccActionButton: Object.assign(Object.assign({}, theme.typography.small_button), { '&.MuiButtonBase-root.MuiButton-root': { padding: `15px ${spacing.xs} 13px ${spacing.xs}` }, flexShrink: 0 }),
}));
export default useStyles;
